// API client for Geographic Order Intelligence.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/geographic-orders`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class ReportUnavailableError extends Error {
  constructor(message) { super(message); this.reportUnavailable = true; }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) search.set(key, value);
  });
  const text = search.toString();
  return text ? `?${text}` : '';
};

// SF2 — promised delivery time by postal region, split by fulfilment type.
export const getDelivery = (token, { start, end, grain } = {}) =>
  call(`${BASE}/delivery${query({ start, end, grain })}`, {
    headers: authHeaders(token),
  });

// SF2, product view — scoped to one region and fulfilment type on purpose.
export const getDeliveryProducts = (token, { start, end, grain, region, fulfilment } = {}) =>
  call(`${BASE}/delivery/products${query({ start, end, grain, region, fulfilment })}`, {
    headers: authHeaders(token),
  });

// SF3 — returns by administrative geography, with the reason beside them.
export const getReturnsGeography = (token, { start, end, grain, state, city } = {}) =>
  call(`${BASE}/returns${query({ start, end, grain, state, city })}`, {
    headers: authHeaders(token),
  });
